import React from 'react'
import { Link } from 'react-router-dom'

const S1_Home = () => {
  return (
      <section className='S1_home'> 
          <div className='container'>
              <div className='row'>
                  <div className='col-lg-6 left'>
                        <h1>Raining Offers For Hot Summer!</h1>

          <h3>25% Off On All Products</h3>

          <ul>
              <li className='shop'> <Link to="" >SHOP NOW</Link> </li>
              <li className='more'> <Link to="/Store">FIND MORE</Link> </li>

          </ul>
                  </div>

            </div>
          </div>

    </section>
  )
}

export default S1_Home